export default __webpack_public_path__ + "90021aad183ca076ab49c732b348e252.svg";